import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useProjectStore } from '@/store/ProjectStore';
import { currentProjectSelector, currentProjectActionsSelector } from '@/selectors/project';
import { useGetSingleProjectData } from '@/reactQuery/get';

export const useCurrentProject = () => {
  const currentProject = useProjectStore(currentProjectSelector);
  const actions = useProjectStore(currentProjectActionsSelector);

  // Only fetch if IDs are provided and we need the data
  const {
    organization_id: organizationId,
    workspace_id: workspaceId,
    project_id: projectId,
  } = useParams();
  const shouldFetch =
    !!(organizationId && workspaceId && projectId) &&
    (!currentProject || currentProject._id !== projectId);

  const { data, isLoading, error } = useGetSingleProjectData(
    organizationId!,
    workspaceId!,
    projectId!,
    { enabled: shouldFetch },
  );

  // Sync fetched data to store
  useEffect(() => {
    if (data && (!currentProject || currentProject._id !== projectId)) {
      actions.setCurrentProject(data);
    }
  }, [data, currentProject, projectId, actions]);

  return {
    currentProject: currentProject || data,
    isLoading,
    error,
    actions,
  };
};
